import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { DeviceProtocol } from '@frontend/device/types';
import React from 'react';

const ID = 'device-protocol-select';
export interface DeviceProtocolSelectProps extends Omit<SelectInputV2Props<DeviceProtocol>, 'options'> {}
export const DeviceProtocolSelect = (props: DeviceProtocolSelectProps) => {
    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Device protocol'}
            options={Object.values(DeviceProtocol).map((c) => ({ label: c, value: c }))}
        />
    );
};
